import React from "react"
import { createRoot } from "react-dom/client"
import { ApolloProvider } from "@apollo/client"
import { BrowserRouter } from "react-router-dom"
import { ThemeProvider } from "styled-components"
import irishLife from "./themes/irishlife"

import client from "./apolloClient"
import App from "./App"

const theme = irishLife

const container = document.getElementById("root")
if (!container) {
  throw new Error("Root file is missing")
}
const root = createRoot(container)
root.render(
  <ApolloProvider client={client}>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </ApolloProvider>
)
